import { useCallback } from "react";
import { useWizard } from "@picklebet/ui";
import type { DepositMethodStepName } from "../utils/registry";
import { useDepositWizard } from "./useDepositWizard";
import { useLastUsedDepositMethod } from "./useLastUsedDepositMethod";

/**
 * The one way a method in the wizard reports a completed deposit. Skrill is the
 * exception: it returns from an off-site redirect into its own terminal step
 * and completes there.
 */
export const useCompleteDeposit = () => {
  const { close, closeOnSuccess, selectedMethod } = useDepositWizard();
  const { goTo } = useWizard<DepositMethodStepName>();
  const [_, setLastUsedMethodId] = useLastUsedDepositMethod();

  return useCallback(() => {
    setLastUsedMethodId(selectedMethod.id);

    if (closeOnSuccess) {
      close();
      return;
    }

    goTo("deposit-success", { replace: true });
  }, [close, closeOnSuccess, goTo, selectedMethod.id, setLastUsedMethodId]);
};
